document.addEventListener('DOMContentLoaded', function () {
  var TARGETS = ['Style', 'Disponibilidad'];

  function getLabel(detail) {
    var el =
      detail.querySelector('.facets__summary-label') ||
      detail.querySelector('.mobile-facets__summary-label') ||
      detail.querySelector('summary .mobile-facets__summary div > span') ||
      detail.querySelector('summary span');

    if (!el) return '';

    var n0 = el.childNodes && el.childNodes[0];
    var t0 = n0 && n0.textContent ? n0.textContent.trim() : '';
    return (t0 || el.textContent || '').trim();
  }

  function shouldHide(label) {
    if (!label) return false;
    var l = label.toLowerCase();
    return TARGETS.some(function (t) {
      return t.toLowerCase() === l;
    });
  }

  function hide() {
    document.querySelectorAll('details.js-filter').forEach(function (detail) {
      var label = getLabel(detail);
      if (shouldHide(label)) {
        detail.style.display = 'none';
        detail.setAttribute('hidden', '');
      }
    });
  }

  hide();

  var root = document.querySelector('facet-filters-form') || document.body;
  new MutationObserver(hide).observe(root, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.mobile-facets__open, .facets__open')) setTimeout(hide, 0);
  });

  document.addEventListener('shopify:section:load', hide);
});